import React from 'react';
import { useSelections } from 'ahooks';

import { AccordionItem, List } from 'src/components/custom';

type Props<T extends object> = {
  data?: T[];
  renderContent?: (data: T) => React.ReactNode;
  renderTitle?: (data: T) => React.ReactNode;
  renderItem?: (data: T) => React.ReactElement;
  itemKey?: number | string;
};

function Accordion<T extends object>({
  data = [],
  renderContent,
  renderTitle,
  renderItem,
  itemKey = 'id',
}: Props<T>) {
  const { selected, toggle } = useSelections<number | string>([]);

  return (
    <List
      className="module"
      columns={1}
      data={data}
      renderItem={
        renderItem ||
        ((data) => (
          <AccordionItem
            border
            itemKey={data[itemKey]}
            title={{
              text: renderTitle?.(data),
            }}
            content={{
              text: renderContent?.(data),
            }}
            isActive={selected.includes(data[itemKey])}
            onTitleClick={() => toggle(data[itemKey])}
          />
        ))
      }
    />
  );
}

export default Accordion;
